const formatNumber = (number) => new Intl.NumberFormat('pl-PL').format(Number(number || 0));

const getReportsVoivodeshipState = (syncKey) => {
	if (!window.stop18ReportsVoivodeshipState) {
		return null;
	}

	return window.stop18ReportsVoivodeshipState[syncKey] || null;
};

const updateReportsVoivodeshipText = (text, data) => {
	if (!text || !data) {
		return;
	}

	const textSyncKey = text.dataset.reportsSyncKey || 'stop18-main';

	if (data.syncKey !== textSyncKey) {
		return;
	}

	const previousWrapper = text.querySelector('[data-reports-previous-wrapper]');
	const currentWrapper = text.querySelector('[data-reports-current-wrapper]');
	const detailsText = text.querySelector('[data-reports-details-text]');

	const previousYearElement = text.querySelector('[data-reports-previous-year]');
	const previousTotalElement = text.querySelector('[data-reports-previous-total]');
	const currentYearElement = text.querySelector('[data-reports-current-year]');
	const currentTotalElement = text.querySelector('[data-reports-current-total]');

	if (previousWrapper) {
		previousWrapper.hidden = !data.previousYear;
	}

	if (currentWrapper) {
		currentWrapper.hidden = !data.currentYear;
	}

	if (detailsText) {
		detailsText.hidden = !data.currentYear;
	}

	if (previousYearElement) {
		previousYearElement.textContent = data.previousYear || '';
	}

	if (previousTotalElement) {
		previousTotalElement.textContent = formatNumber(data.previousTotal);
	}

	if (currentYearElement) {
		currentYearElement.textContent = data.currentYear || '';
	}

	if (currentTotalElement) {
		currentTotalElement.textContent = formatNumber(data.currentTotal);
	}
};

const initReportsVoivodeshipText = () => {
	const texts = document.querySelectorAll('.js-reports-voivodeship-text');

	texts.forEach((text) => {
		const syncKey = text.dataset.reportsSyncKey || 'stop18-main';
		const data = getReportsVoivodeshipState(syncKey);

		updateReportsVoivodeshipText(text, data);
	});
};

window.addEventListener('stop18:reports-voivodeship:update', (event) => {
	const texts = document.querySelectorAll('.js-reports-voivodeship-text');

	texts.forEach((text) => {
		updateReportsVoivodeshipText(text, event.detail);
	});
});

document.addEventListener('DOMContentLoaded', initReportsVoivodeshipText);

if (window.elementorFrontend) {
	window.elementorFrontend.hooks.addAction(
		'frontend/element_ready/stop18_reports_voivodeship_text.default',
		initReportsVoivodeshipText
	);
}